const FNV_OFFSET_BASIS = 2166136261;
const FNV_PRIME = 16777619;

export const buildProfilePhotoThumbnailUrl = (
  relationId: number | undefined,
  hasProfilePhoto: boolean,
  originalUrl?: string | null
): string | null => {
  if (!hasProfilePhoto || !Number.isSafeInteger(relationId) || !relationId || relationId <= 0) {
    return null;
  }

  const baseUrl = `/umbraco/api/SecureMedia/ProfilePhotoThumbnail?relationId=${relationId}`;
  if (!originalUrl) return baseUrl;

  try {
    // Replacements change the file name; expiring S3 query parameters must not bust this cache.
    const fileName = new URL(originalUrl, 'https://local.invalid').pathname.split('/').pop();
    if (!fileName) return baseUrl;

    let photoVersionHash = FNV_OFFSET_BASIS;
    for (let index = 0; index < fileName.length; index += 1) {
      photoVersionHash = Math.imul(photoVersionHash ^ fileName.charCodeAt(index), FNV_PRIME);
    }
    return `${baseUrl}&v=${(photoVersionHash >>> 0).toString(36)}`;
  } catch {
    return baseUrl;
  }
};
